//import WordInsideFindListArea from "@/pages/comp/plan/word/word_inside/common/find_list";
import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ViewCGWordArrPopup from "@/pages/comp/book_order/textbook/popup/view_cg_word_arr";
import getXcolumnJson from "./xcolumn/list";
import SearchArea from "@/pages/comp/plan/word/word_inside/common/list/area/search";
import ManageBtnArea from "./area/manage_btn";

function WordInsideFindListArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    listOpt: {},
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_title_like: "",
    s_word_type: "",
    order_id: "a_title",
    s_addon_study_word: "1",
    ...myProps.listOpt
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "view_cg_word_arr",
    cg_word_pri_val_arr: [],
    voice: "",
    title: "팝업",
    width: "800px",
    height: "90%",
  });

  useEffect(() => {
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const select_finish = (inData: any) => {
    let selected_rows = ListComponentRef.current.getSelectedRows();
    let opt_obj = {
      selected_rows: selected_rows,
      ...inData
    };
    selected_rows = opt_obj.selected_rows;
    if (selected_rows.length == 0) {
      alert("선택된 학습이 없습니다.");
      return;
    }

    myProps.callbackData({
      info_arr: selected_rows,
    });
    myProps.closePopup();
  };

  const open_cg_word_arr_popup = (inData: any) => {
    let opt_obj = {
      cg_word_arr: [],
      voice: "",
      ...inData
    };

    let popup_sort = "cg_word_arr";
    let cg_word_pri_val_arr: any = [];
    for (let i = 0; i < opt_obj.cg_word_arr.length; i++) {
      let cg_word_item = opt_obj.cg_word_arr[i];
      cg_word_pri_val_arr.push(cg_word_item.row_pri_val);
    }

    if (cg_word_pri_val_arr.length == 0) {
      return false;
    }

    setPopupData({
      ...popupData,
      cg_word_pri_val_arr: cg_word_pri_val_arr,
      isOpen: true,
      sort: popup_sort,
      title: "단어보기",
    });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    let val_str = params.value;
    if (params.key == "row_view_word_count") {
      let tmp_cg_word_arr: any = [];
      if (params.rowData["cg_word_arr"]) {
        tmp_cg_word_arr = params.rowData["cg_word_arr"];
        val_str = strFunc.comma(params.rowData["cg_word_arr"].length);
      }
      val_str = (
        <a className='text-center'
          onClick={() => {
            open_cg_word_arr_popup({
              cg_word_arr: tmp_cg_word_arr,
            });
          }}>
          {val_str}개
        </a>
      );
    }

    return val_str;
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        list={list}
      ></SearchArea>
      <ManageBtnArea
        select_finish={select_finish}
      ></ManageBtnArea>
      <div className="mt-1">
        <ListComponent
          ref={ListComponentRef}
          xColumnArr={{ ...xColumnArr }}
          gridOpt={{
            fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
            is_add_idx_num: false,
            is_add_checkbox: true,
            td_align: "center",
            height: "auto",
            is_fix_width: true,
            rowMultiSelectWithClick: false,
            onGridReady: () => {

            },

            is_all_select_row_key: true,
            rowOnClick: rowOnClick,
            customCellRenderer: customCellRenderer,
            class_name_json: {
              table_div: "basic_list_div",
              td_div: "row-col-div",
              input_check: "chk_row",
              row_input: "row-input",
              data_row_tr: "data_row_tr",
              active_row: "active",
              empty_con_div: "list_empty_content_div",
            },
          }}
        ></ListComponent>
      </div>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        is_view_num_per_page={true}
        is_show_total_rec={true}
        onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "cg_word_arr" &&
            <ViewCGWordArrPopup
              cg_word_pri_val_arr={popupData.cg_word_pri_val_arr}
              voice={popupData.voice}
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></ViewCGWordArrPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default WordInsideFindListArea;